import { GtmCustomData, recordEventWrapper } from '..';
import { getPageLabelForMutualFundHomeCardClick } from '../utils';

const mflp = () => ({
  // mflpPageLoad: (data: GtmCustomData) => {
  //   recordEventWrapper({
  //     event: 'event',
  //     page: 'page',
  //     title: 'title',
  //     ...data,
  //   });
  // },
  // homeIconClick: (fundCategory?: string) => {
  //   recordEventWrapper({
  //     event: 'event_pfm',
  //     category: 'PFM',
  //     action: `mutual funds | ${fundCategory}`,
  //     label: "home"
  //   });
  // },
  mutualFundHomePageLoad: () => {
    recordEventWrapper({
      event: 'event_pfm_onload_vpv',
      page: 'vpv/pfm/mutual-funds-dashboard',
      title: 'PFM - Mutual Funds Dashboard',
    }),
    recordEventWrapper({
      event: 'event_pfm_onload',
      category: 'PFM',
      action: `Pageload`,
      label: "Mutual funds dashboard"
    })
  },
  mutualFundTileClick: (tileLabel: string) => {
    recordEventWrapper({
      event: 'event_pfm',
      category: 'PFM',
      action: `mutual fund dashboard | tiles`,
      label: getPageLabelForMutualFundHomeCardClick(tileLabel),
    })
  },
});

export default mflp;
